import React, { FC } from 'react';
import styled from 'styled-components';
import usePlayUser from '@fenderdigital/custom-hooks/hooks/usePlayUser';
import Link from '../Link';
import { clearLocalStorage, getSignOutLink, getSignInUrlWithSession } from '../../lib/cognito';

const MenuUserContainer = styled.div`
  font-family: ${({ theme: { fonts } }): string => fonts.futuraHeavy};
`;

interface MenuUserLinkProps {
  isProfileLink?: boolean;
}

const MenuUserLink = styled.a<MenuUserLinkProps>`
  display: block;
  padding: 1rem;

  font-size: ${({ theme: { fontSizes } }): string => fontSizes.f2};
  text-transform: uppercase;
  text-decoration: none;

  color: ${({ isProfileLink, theme: { colors } }): string =>
    isProfileLink ? colors.red : colors.darkGray};
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`;

const UnSubscribedMobileMenuUser: FC = () => {
  const { user, hasCheckedSession } = usePlayUser();
  const signInURL = getSignInUrlWithSession();
  return (
    <MenuUserContainer>
      {user && (
        <>
          <MenuUserLink
            as={Link}
            isProfileLink
            to={`${process.env.REACT_APP_CLIENT_SSO_URL}/profile/info`}
          >
            Hi, {user?.['first-name']}
          </MenuUserLink>
          <MenuUserLink as={Link} to={getSignOutLink(false)} onClick={clearLocalStorage}>
            Sign Out
          </MenuUserLink>
        </>
      )}
      {!user && hasCheckedSession && (
        <MenuUserLink as={Link} to={signInURL}>
          Sign In
        </MenuUserLink>
      )}
    </MenuUserContainer>
  );
};

export default UnSubscribedMobileMenuUser;
